import React from 'react';
import { Icons, NamedLink } from '../../components';
import css from './GlobalBottomNavMobile.module.css';
import { classNames } from 'primereact/utils';

function GlobalBottomNavMobile({ isListingPage = false }) {
  return (
    <div className={classNames(css.bottomNavbar, {
      [css.listingNavbar] : isListingPage
    })}>
      <NamedLink name="SearchPage">
        <Icons name="searchIcon" />
      </NamedLink>
      <NamedLink name="WishlistPage" className={css.navLink}>
        <Icons name="wishlist" />
      </NamedLink>
      <NamedLink name="LandingPage">
        <Icons name="home" />
      </NamedLink>
      <NamedLink name="InboxPage" params={{ tab: 'orders' }}>
        <Icons name="envelope" />
      </NamedLink>
      <NamedLink name="AccountSettingsPage">
        <Icons name="account" />
      </NamedLink>
    </div>
  );
}

export default GlobalBottomNavMobile;
